import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useNotifications } from "../context/NotificationsContext";
import { useTranslation } from "../context/TranslationContext";
import CoordinatorDashboard from "./CoordinatorDashboard";
import PortalSelector, { PORTALS } from "./PortalSelector";
import ViewAllClients from "./ViewAllClients";

export const canViewCoordinatorPortal = (capabilities) =>
  Boolean(capabilities?.canAccessCoordinator);

const PortalDashboard = () => {
  const { user } = useAuth();
  const { t } = useTranslation();
  const location = useLocation();
  const [activePortal, setActivePortal] = useState(PORTALS.COCOUNSEL);
  const canViewCoordinator = canViewCoordinatorPortal(user?.capabilities);
  const { refreshInBackground } = useNotifications();

  // Landing on (or returning to) the dashboard refreshes the bell without blocking the page.
  useEffect(() => {
    refreshInBackground();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (canViewCoordinator && location.state?.activePortal === PORTALS.COORDINATOR) {
      setActivePortal(PORTALS.COORDINATOR);
    }
  }, [canViewCoordinator, location.state?.activePortal]);

  const selector = (
    <PortalSelector
      canViewCoordinator={canViewCoordinator}
      value={activePortal}
      onChange={setActivePortal}
      labels={{
        selector: t("portal.selector"),
        cocounsel: t("portal.cocounsel"),
        coordinator: t("portal.coordinator"),
      }}
    />
  );

  if (canViewCoordinator && activePortal === PORTALS.COORDINATOR) {
    return <CoordinatorDashboard portalSelector={selector} />;
  }

  return <ViewAllClients portalSelector={selector} />;
};

export default PortalDashboard;
